<template>
  <div>
    <div class="content-title">账户充值
      <span>{{platinfo}}</span>
    </div>
    <div style="padding: 20px; border: 1px solid #e4d6d6;">
      <span class="available-money-class"><span>账户余额:</span> {{ availableMoney }}元</span>
      <el-button type="primary" @click="addrecharge">账户充值</el-button>
      <!-- <el-button type="primary" @click="limitUserDialog">新增转账限额用户</el-button> -->
      <!-- <span>转账限额用户每次转账金额不大于 9.8 万 (九万八千) 元</span> -->
    </div>
    <div class="content-table">
      <el-table :data="recharges" size='medium' tooltip-effect="dark">
        <el-table-column prop="payName" label="付款人" width="300px"></el-table-column>
        <el-table-column prop="payAccount" label="付款账户"></el-table-column>
        <el-table-column prop="recvName" label="收款人"></el-table-column>
        <el-table-column prop="recvAccount" label="收款账户"></el-table-column>
        <el-table-column prop="money" label="转账金额"></el-table-column>
        <el-table-column prop="payDate" label="付款日期" align="center"></el-table-column>
        <el-table-column prop="rechargeStatus" label="状态" align="center">
          <template slot-scope="scope"><span>{{ scope.row.rechargeStatus | parseChargeStatus }}</span></template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="新增转账限额用户" width="600px" :visible.sync="limitUserVisible" append-to-body>
      <el-form ref="form" :model="providerLimitUser" label-width="120px">
        <el-form-item label="用户姓名：" style="margin-bottom: 20px;">
          <el-input v-model="providerLimitUser.userName" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="用户身份证号：" style="margin-bottom: 20px;">
          <el-input v-model="providerLimitUser.userAccno" style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirmButton">保存</el-button>
          <el-button @click="limitUserVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'recharges',
  data() {
    return {
      recharges: [],
      availableMoney: 0.0,
      providerTotalMoney: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      limitUserVisible: false,
      providerLimitUser: {
        userName: '',
        userAccno: '',
      },
      platinfo: '',
    };
  },
  filters: {
    parseChargeStatus(rechargeStatus) {
      if (rechargeStatus === 0) {
        return '审核确认中';
      } else if (rechargeStatus === 1) {
        return '审核通过';
      } else if (rechargeStatus === 2) {
        return '审核不通过';
      }
      return '';
    },
  },
  mounted() {
    if (this.$store.state.plat === 1) {
      this.platinfo = '  户名：萍乡市迅果科技有限公司     开户行：招商银行上海金沙江路支行    账号： 574908432410606 ';
    } else if (this.$store.state.plat === 2) {
      this.platinfo = '  户名：江西迅启启丰信息科技有限公司     开户行：招商银行上海金沙江路支行    账号： 574908432410606 ';
    }
    this.fetchProviderTotalMoney();
    this.fetchRecharges();
  },
  methods: {
    addrecharge() {
      this.$router.push({ path: 'addrecharge' });
    },
    fetchRecharges() {
      this.recharges = [];
      api.fetchRecharges({
        params: {
          params: {
            index: this.currentPage - 1,
            size: this.pageSize,
          },
        },
      }).then((res) => {
        console.log('fetchRecharges', res);
        this.recharges = [];
        this.total = 0;
        if (!res) {
          return;
        }
        this.total = res.count;
        if (!res.data) {
          return;
        }
        this.recharges = res.data;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchRecharges();
    },
    fetchProviderTotalMoney() {
      api.fetchProviderTotalMoney().then((res) => {
        console.log('fetchProviderTotalMoney', res);
        if (!res) {
          return;
        }
        this.providerTotalMoney = res;
        this.availableMoney = (this.providerTotalMoney.incomeMoney - this.providerTotalMoney.outcomeMoney - this.providerTotalMoney.serviceCost).toFixed(2);
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    limitUserDialog() {
      this.limitUserVisible = true;
    },
    confirmButton() {
      this.$confirm('新增转账限额用户：'.concat(this.providerLimitUser.userName, '，身份证号：', '', this.providerLimitUser.userAccno), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.addLimitUser();
      });
    },
    addLimitUser() {
      api.addLimitUser({
        params: {
          data: this.providerLimitUser,
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: '新增成功',
        });
        this.limitUserVisible = false;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.available-money-class {
  font-size: 18px;
  color: #188fff;
  margin-right: 40px;
  letter-spacing: 3px;
  font-weight: bold;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item{
  margin-bottom: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/recharges.vue